import React from "react";
import {useTranslation} from "react-i18next";
import {DataTable, Page} from "@vedmarket/ui-kit";

import {useProductsList} from "../../../../../../../../../../../../../api/calc";
import {RESULTS_COUNT} from "../../../../../../../../../../../../../utils/constants";
import getHeadCells from "./components/getHeadCells";
import getPreferences from "./components/getPreferences";
import getProductListFlags from "./components/getProductListFlags";
import getProductListRows from "./components/getProductListRows";
import {useCalculationReadOnly} from '../../../../../../../../../../calculation-read-only';

import './product_list_table.scss';

type Props = {
    selectedRows?: string[];
    currentProducts?: string[]
    activeColumns: string[]
    onEdit(id: number): void
    onRemove(id: number): void
    handleProductsListRequest(data?: DictionaryParamsInput): void
    onSearch(query: string): void
    chooseProduct(id: string[]): void
    setActiveColumns(id: any): void
}

const ProductListTable = ({
  onEdit,
  onRemove,
  handleProductsListRequest,
  onSearch,
  chooseProduct,
  currentProducts,
  activeColumns,
  setActiveColumns
}: Props) => {

  const { t } = useTranslation()
  const readOnly = useCalculationReadOnly()

  const productsList = useProductsList()?.data;

  const productListFlags = getProductListFlags(productsList?.results);

  const handleChangeColumn = (id: string): void => {
    setActiveColumns((prevColumns: string[]) =>
      prevColumns.includes(id)
        ? prevColumns.filter((column) => column !== id)
        : [ ...prevColumns, id ]
    );
  }

  const rows = getProductListRows({
    products: productsList?.results,
    onEdit,
    onRemove,
    readOnly,
    t,
  }) || [];

  const table = <DataTable
    rows={rows}
    count={productsList?.count}
    preferences={getPreferences({
      activeColumns,
      ...productListFlags,
    })}
    chooseItem={chooseProduct}
    primaryField='name'
    handleSendRequest={handleProductsListRequest}
    hasEmptySelection={!currentProducts?.length}
    headCells={getHeadCells({
      activeColumns,
      handleChangeColumn,
      t,
      ...productListFlags,
    })}
    defaultRowsPerPage={RESULTS_COUNT.COUNT_50}
    rowsPerPageOptions={[ RESULTS_COUNT.COUNT_50, RESULTS_COUNT.COUNT_100, RESULTS_COUNT.COUNT_500 ]}
  />

  return (
    <Page
      table={table}
      onSearch={onSearch}
      noBottomPadding
      isAuto
    />
  )
};

export default ProductListTable
